.infoButton {
  position: absolute;
  right: 0;
  top: -5px;
  cursor: pointer;
  user-select: none;
}

.image {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  vertical-align: middle;
  opacity: 0.50;
}

.info {
  font-size: 11px;
  color: rgba(0,0,0,.69);
  vertical-align: middle;
  text-decoration: underline;
}

.infoButton:hover .info {
  color: black;
}
